export const BASE_URL = process.env.REACT_APP_API_BASE_URL as string;
// Base URL of the image-server. Uploaded images are stored as
// domain-less relative paths (e.g. "images/vip/x.png"); this is prepended to
// render them.
export const IMAGE_URL = process.env.REACT_APP_API_IMAGE_URL as string;
export const STORE_KEY = process.env.REACT_APP_API_STORE_KEY as string;
